import React from "react";

export const CaretLeftIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={props.width ?? 24}
    height={props.height ?? 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M9.225 12.4884L16.575 19.8384C16.825 20.0884 16.946 20.38 16.938 20.7134C16.93 21.0467 16.8007 21.3384 16.55 21.5884C16.2993 21.8384 16.0077 21.9634 15.675 21.9634C15.3423 21.9634 15.0507 21.8384 14.8 21.5884L7.1 13.9134C6.9 13.7134 6.75 13.4884 6.65 13.2384C6.55 12.9884 6.5 12.7384 6.5 12.4884C6.5 12.2384 6.55 11.9884 6.65 11.7384C6.75 11.4884 6.9 11.2634 7.1 11.0634L14.8 3.36337C15.05 3.11337 15.346 2.99237 15.688 3.00037C16.03 3.00837 16.3257 3.13771 16.575 3.38837C16.8243 3.63904 16.9493 3.93071 16.95 4.26337C16.9507 4.59604 16.8257 4.88771 16.575 5.13837L9.225 12.4884Z" fill={props.fill ?? "currentColor"}/>
  </svg>
);

export default CaretLeftIcon;



